module.exports = __webpack_public_path__ + "a06cdf94afd3b63a62444fcc0f5c86b5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-wizard.png
// module id = 3202
// module chunks = 0